export default {"src":"/_next/static/media/Gastero.44f72e73.svg","height":91,"width":90,"blurWidth":0,"blurHeight":0};